import React, { useState } from 'react';
import { Slider } from '../Slider';
import { Panel, PanelTheme } from '../Panel';

export const SliderDemo: React.FC = () => {
    // Example: full range is 0 to 100, reserved area from 0 to 20.
    const min = 0;
    const max = 100;
    const reserved = 70;
    // Initial value, must be >= reserved
    const [value, setValue] = useState(70);

    return (
        <div style={{ padding: '1rem', maxWidth: '500px' }}>
            <div style={{ marginTop: '20px', marginBottom: '20px' }}>
                <li style={{ color: 'grey' }}>Slider</li>
                <Panel
                    theme={PanelTheme.White}
                    width='520px'
                >
                    <Slider
                        value={value}
                        min={min}
                        max={max}
                        reserved={reserved}
                        onValueChanged={setValue}
                    />
                </Panel>
            </div>
        </div>
    );
};
